/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getVitals } from 'app/entities/vitals/vitals.reducer';
import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { TypeOfAnaesthesia } from 'app/shared/model/enumerations/type-of-anaesthesia.model';
import { Induction } from 'app/shared/model/enumerations/induction.model';
import { OPInhalational } from 'app/shared/model/enumerations/op-inhalational.model';
import { OPEtube } from 'app/shared/model/enumerations/op-etube.model';
import { OPVentilation } from 'app/shared/model/enumerations/op-ventilation.model';
import { Spontaneous } from 'app/shared/model/enumerations/spontaneous.model';
import { PatientPosition } from 'app/shared/model/enumerations/patient-position.model';
import { createEntity, getEntity, reset, updateEntity } from './pre-op-anaesthesia-chart.reducer';

export const PreOpAnaesthesiaChartUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const vitals = useAppSelector(state => state.vitals.entities);
  const nurses = useAppSelector(state => state.nurse.entities);
  const preOpAnaesthesiaChartEntity = useAppSelector(state => state.preOpAnaesthesiaChart.entity);
  const loading = useAppSelector(state => state.preOpAnaesthesiaChart.loading);
  const updating = useAppSelector(state => state.preOpAnaesthesiaChart.updating);
  const updateSuccess = useAppSelector(state => state.preOpAnaesthesiaChart.updateSuccess);
  const typeOfAnaesthesiaValues = Object.keys(TypeOfAnaesthesia);
  const inductionValues = Object.keys(Induction);
  const oPInhalationalValues = Object.keys(OPInhalational);
  const oPEtubeValues = Object.keys(OPEtube);
  const oPVentilationValues = Object.keys(OPVentilation);
  const spontaneousValues = Object.keys(Spontaneous);
  const patientPositionValues = Object.keys(PatientPosition);

  const handleClose = () => {
    navigate(`/pre-op-anaesthesia-chart${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getDoctors({}));
    dispatch(getVitals({}));
    dispatch(getNurses({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.torniquetAppliedAt !== undefined && typeof values.torniquetAppliedAt !== 'number') {
      values.torniquetAppliedAt = Number(values.torniquetAppliedAt);
    }
    if (values.torniquetRemovedAt !== undefined && typeof values.torniquetRemovedAt !== 'number') {
      values.torniquetRemovedAt = Number(values.torniquetRemovedAt);
    }
    if (values.timeOfInduction !== undefined && typeof values.timeOfInduction !== 'number') {
      values.timeOfInduction = Number(values.timeOfInduction);
    }
    if (values.timeOfIndcision !== undefined && typeof values.timeOfIndcision !== 'number') {
      values.timeOfIndcision = Number(values.timeOfIndcision);
    }
    if (values.timeOfSurgeyCompletion !== undefined && typeof values.timeOfSurgeyCompletion !== 'number') {
      values.timeOfSurgeyCompletion = Number(values.timeOfSurgeyCompletion);
    }
    if (values.timeOfExtubation !== undefined && typeof values.timeOfExtubation !== 'number') {
      values.timeOfExtubation = Number(values.timeOfExtubation);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...preOpAnaesthesiaChartEntity,
      ...values,
      surgery: patientProcedures.find(it => it.id.toString() === values.surgery?.toString()),
      anaesthesiologist: doctors.find(it => it.id.toString() === values.anaesthesiologist?.toString()),
      vitals: vitals.find(it => it.id.toString() === values.vitals?.toString()),
      nurse: nurses.find(it => it.id.toString() === values.nurse?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          typeOfAnaesthesia: 'GA',
          induction: 'IV',
          inhalational: 'AIRWAY',
          etube: 'NASAL',
          ventilation: 'CONTOLLED',
          spontaneous: 'CIRCUIT',
          patientPosition: 'SUPINE',
          ...preOpAnaesthesiaChartEntity,
          surgery: preOpAnaesthesiaChartEntity?.surgery?.id,
          anaesthesiologist: preOpAnaesthesiaChartEntity?.anaesthesiologist?.id,
          vitals: preOpAnaesthesiaChartEntity?.vitals?.id,
          nurse: preOpAnaesthesiaChartEntity?.nurse?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.preOpAnaesthesiaChart.home.createOrEditLabel" data-cy="PreOpAnaesthesiaChartCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.preOpAnaesthesiaChart.home.createOrEditLabel">
              Create or edit a PreOpAnaesthesiaChart
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pre-op-anaesthesia-chart-id"
                  label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.typeOfAnaesthesia')}
                id="pre-op-anaesthesia-chart-typeOfAnaesthesia"
                name="typeOfAnaesthesia"
                data-cy="typeOfAnaesthesia"
                type="select"
              >
                {typeOfAnaesthesiaValues.map(typeOfAnaesthesia => (
                  <option value={typeOfAnaesthesia} key={typeOfAnaesthesia}>
                    {translate(`tinyMedicRestApp.TypeOfAnaesthesia.${typeOfAnaesthesia}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.generalCondition')}
                id="pre-op-anaesthesia-chart-generalCondition"
                name="generalCondition"
                data-cy="generalCondition"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.ivAccess')}
                id="pre-op-anaesthesia-chart-ivAccess"
                name="ivAccess"
                data-cy="ivAccess"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.site')}
                id="pre-op-anaesthesia-chart-site"
                name="site"
                data-cy="site"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.cannulaGuage')}
                id="pre-op-anaesthesia-chart-cannulaGuage"
                name="cannulaGuage"
                data-cy="cannulaGuage"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.raTechnique')}
                id="pre-op-anaesthesia-chart-raTechnique"
                name="raTechnique"
                data-cy="raTechnique"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.raApproach')}
                id="pre-op-anaesthesia-chart-raApproach"
                name="raApproach"
                data-cy="raApproach"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.raNeedle')}
                id="pre-op-anaesthesia-chart-raNeedle"
                name="raNeedle"
                data-cy="raNeedle"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.raSpace')}
                id="pre-op-anaesthesia-chart-raSpace"
                name="raSpace"
                data-cy="raSpace"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.raDrug')}
                id="pre-op-anaesthesia-chart-raDrug"
                name="raDrug"
                data-cy="raDrug"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.raOnsetAction')}
                id="pre-op-anaesthesia-chart-raOnsetAction"
                name="raOnsetAction"
                data-cy="raOnsetAction"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.raSensoryLevel')}
                id="pre-op-anaesthesia-chart-raSensoryLevel"
                name="raSensoryLevel"
                data-cy="raSensoryLevel"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.raMotorLevel')}
                id="pre-op-anaesthesia-chart-raMotorLevel"
                name="raMotorLevel"
                data-cy="raMotorLevel"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.gaPreOxygenation')}
                id="pre-op-anaesthesia-chart-gaPreOxygenation"
                name="gaPreOxygenation"
                data-cy="gaPreOxygenation"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.induction')}
                id="pre-op-anaesthesia-chart-induction"
                name="induction"
                data-cy="induction"
                type="select"
              >
                {inductionValues.map(induction => (
                  <option value={induction} key={induction}>
                    {translate(`tinyMedicRestApp.Induction.${induction}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.inhalational')}
                id="pre-op-anaesthesia-chart-inhalational"
                name="inhalational"
                data-cy="inhalational"
                type="select"
              >
                {oPInhalationalValues.map(oPInhalational => (
                  <option value={oPInhalational} key={oPInhalational}>
                    {translate(`tinyMedicRestApp.OPInhalational.${oPInhalational}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.etube')}
                id="pre-op-anaesthesia-chart-etube"
                name="etube"
                data-cy="etube"
                type="select"
              >
                {oPEtubeValues.map(oPEtube => (
                  <option value={oPEtube} key={oPEtube}>
                    {translate(`tinyMedicRestApp.OPEtube.${oPEtube}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.etSize')}
                id="pre-op-anaesthesia-chart-etSize"
                name="etSize"
                data-cy="etSize"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.etCuff')}
                id="pre-op-anaesthesia-chart-etCuff"
                name="etCuff"
                data-cy="etCuff"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.etOtherInfo')}
                id="pre-op-anaesthesia-chart-etOtherInfo"
                name="etOtherInfo"
                data-cy="etOtherInfo"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.ventilation')}
                id="pre-op-anaesthesia-chart-ventilation"
                name="ventilation"
                data-cy="ventilation"
                type="select"
              >
                {oPVentilationValues.map(oPVentilation => (
                  <option value={oPVentilation} key={oPVentilation}>
                    {translate(`tinyMedicRestApp.OPVentilation.${oPVentilation}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.spontaneous')}
                id="pre-op-anaesthesia-chart-spontaneous"
                name="spontaneous"
                data-cy="spontaneous"
                type="select"
              >
                {spontaneousValues.map(spontaneous => (
                  <option value={spontaneous} key={spontaneous}>
                    {translate(`tinyMedicRestApp.Spontaneous.${spontaneous}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.ventilatorMv')}
                id="pre-op-anaesthesia-chart-ventilatorMv"
                name="ventilatorMv"
                data-cy="ventilatorMv"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.ventilatorRr')}
                id="pre-op-anaesthesia-chart-ventilatorRr"
                name="ventilatorRr"
                data-cy="ventilatorRr"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.ventilatorTv')}
                id="pre-op-anaesthesia-chart-ventilatorTv"
                name="ventilatorTv"
                data-cy="ventilatorTv"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.ventilatorIvRatio')}
                id="pre-op-anaesthesia-chart-ventilatorIvRatio"
                name="ventilatorIvRatio"
                data-cy="ventilatorIvRatio"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.patientPosition')}
                id="pre-op-anaesthesia-chart-patientPosition"
                name="patientPosition"
                data-cy="patientPosition"
                type="select"
              >
                {patientPositionValues.map(patientPosition => (
                  <option value={patientPosition} key={patientPosition}>
                    {translate(`tinyMedicRestApp.PatientPosition.${patientPosition}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.torniquetAppliedAt')}
                id="pre-op-anaesthesia-chart-torniquetAppliedAt"
                name="torniquetAppliedAt"
                data-cy="torniquetAppliedAt"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.torniquetRemovedAt')}
                id="pre-op-anaesthesia-chart-torniquetRemovedAt"
                name="torniquetRemovedAt"
                data-cy="torniquetRemovedAt"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.timeOfInduction')}
                id="pre-op-anaesthesia-chart-timeOfInduction"
                name="timeOfInduction"
                data-cy="timeOfInduction"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.timeOfIndcision')}
                id="pre-op-anaesthesia-chart-timeOfIndcision"
                name="timeOfIndcision"
                data-cy="timeOfIndcision"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.timeOfSurgeyCompletion')}
                id="pre-op-anaesthesia-chart-timeOfSurgeyCompletion"
                name="timeOfSurgeyCompletion"
                data-cy="timeOfSurgeyCompletion"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.timeOfExtubation')}
                id="pre-op-anaesthesia-chart-timeOfExtubation"
                name="timeOfExtubation"
                data-cy="timeOfExtubation"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.additionalNotes')}
                id="pre-op-anaesthesia-chart-additionalNotes"
                name="additionalNotes"
                data-cy="additionalNotes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.active')}
                id="pre-op-anaesthesia-chart-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.cursor')}
                id="pre-op-anaesthesia-chart-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.lastupdated')}
                id="pre-op-anaesthesia-chart-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.microSec')}
                id="pre-op-anaesthesia-chart-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.timestampentry')}
                id="pre-op-anaesthesia-chart-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="pre-op-anaesthesia-chart-surgery"
                name="surgery"
                data-cy="surgery"
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.surgery')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pre-op-anaesthesia-chart-anaesthesiologist"
                name="anaesthesiologist"
                data-cy="anaesthesiologist"
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.anaesthesiologist')}
                type="select"
                required
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pre-op-anaesthesia-chart-vitals"
                name="vitals"
                data-cy="vitals"
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.vitals')}
                type="select"
                required
              >
                <option value="" key="0" />
                {vitals
                  ? vitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="pre-op-anaesthesia-chart-nurse"
                name="nurse"
                data-cy="nurse"
                label={translate('tinyMedicRestApp.preOpAnaesthesiaChart.nurse')}
                type="select"
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pre-op-anaesthesia-chart" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PreOpAnaesthesiaChartUpdate;
